import { logOut, setAlert } from "utils/helper";

export const errorHandler = (error) => {
  console.log(error);
  if(error.toJSON().message === "Network Error"){
    setAlert("Check your internet connection")
    return ""
}

  let message = "";
  let defaultMessage = "Something went wrong, please try again.";
  if (error?.response) {
    let status = error.response.status;
    if (status >= 500 && status < 600) {
      setAlert(defaultMessage)
      return defaultMessage;
    }

    if (status === 401 || status === 403) {
      logOut();
    } else {
      message = error.response.data.error_description || defaultMessage;
      if (status === 404 || status === 400) {
        return {
          status,
          message,
        };
      }
    }
  } else {
    message = error?.message || defaultMessage;
  }
  return message;
};
